module.exports = "\r\n<router-outlet></router-outlet>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main